Ext.define('SA.AcsTable.ModelState', {
    constructor({
        viewName,
        edition,
        tableId,
        censusReleaseYear,
        selectedLocations,
        selectableLocations,
        unselectableLocations
    }) {
        this.viewName = viewName;
        this.edition = edition;
        this.tableId = tableId;
        this.censusReleaseYear = censusReleaseYear;
        this.selectedLocations = selectedLocations;
        this.selectableLocations = selectableLocations;
        this.unselectableLocations = unselectableLocations;
    },

    getCensusReleaseYear() {
        return this.censusReleaseYear;
    },

    getEdition() {
        return this.edition;
    },

    getReasonUnviewable() {
        return !this.hasSelectableLocations() ? 'NoSelectableLocations' : 'NoSelectedLocations';
    },

    getSelectableLocations() {
        return this.selectableLocations;
    },

    getSelectedLocations() {
        return this.selectedLocations;
    },

    getTableId() {
        return this.tableId;
    },

    getUnselectableLocations() {
        return this.unselectableLocations;
    },

    getViewName() {
        return this.viewName;
    },

    hasSelectableLocations() {
        return this.getSelectableLocations().length > 0;
    },

    hasSelectedLocations() {
        return this.getSelectedLocations().length > 0;
    },

    hasUnselectableLocations() {
        return this.getUnselectableLocations().length > 0;
    },

    isSelectedLocationId(id) {
        return this.getSelectedLocations().some(location => location.hasStringId(id));
    },

    isViewable() {
        return this.hasSelectedLocations();
    }
});